import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { parse } from 'query-string';
import {
	Application, LoadingIndicator, List, A, Redirect, connectedComponent
} from 'gwx-voyager-components';
import { loadInvitations } from '../invitations.actions';
import { loadProfile } from '../../Profile/profile.actions';
import { parseAttributes, profileName } from '../../Profile/ProfileUtils';

/**
 * Containing component that presents the Invitations for the logged in user
 */
class InvitationList extends Component {
	UNSAFE_componentWillMount() {
		this.props.fetchInvitations(this.props.query);
		this.props.fetchProfile(this.props.profileId);
	}

	render() {
		if (this.props.isFetching) {
			return <LoadingIndicator />;
		}

		const attributes = parseAttributes(this.props.profile, this.props.profileId);

		const pageNumber = parseInt(this.props.query.page, 10) || 0;

		if (pageNumber === 0 && this.props.invitations.length === 1) {
			return <Redirect to={`/${this.props.invitations[0].communityId}/claim/${this.props.invitations[0].id}`} />;
		}

		const rows = this.props.invitations.map((inv) => ({
			id: inv.id,
			cells: [
				<A href={`/${inv.communityId}/claim/${inv.id}`} reactRouter>
					{inv.communityName}
				</A>,
				inv.firstName,
				inv.lastName,
				inv.email
			]
		}));
		const listProps = {
			gridClass: 'invitations-grid',
			headers: [
				'Community',
				'First Name',
				'Last Name',
				'Email'
			],
			isFetching: this.props.isFetching,
			pagination: {
				nextPage: this.props.nextPage,
				previousPage: this.props.previousPage,
				startCount: this.props.startCount,
				endCount: this.props.endCount,
				total: this.props.totalCount
			},
			rows
		};

		return (
			<Application
				navigation={{
					brand: {
						brandName: 'Cerner Care Notifications', brandIconName: 'id-badge', brandClass: 'brand-name', brandUrl: '/'
					},
					navigationRight: [{ type: 'dropdown', display: profileName(attributes, this.props.username), options: [{ href: `/profile/${this.props.profileId}`, display: 'Profile' }, { href: this.props.helpLink, display: 'Help' }, { href: this.props.logoutLink, display: 'Logout' }] }]
				}}
				timeout={{ delay: this.props.timeout }}
			>
				{this.props.invitations.length > 0
					? <List {...listProps} />
					: (this.props.noVerifiedEmail
						? (
							<p className='alert alert-info lead text-center'>
								You have no verified email address, check your profile page and 
								either add an email address and verify or verify an existing email address.
								<br></br>
								<A href={`/profile/${this.props.profileId}`} reactRouter>
									Profile
								</A>
							</p>
						)
						: (
							<p className='alert alert-info lead text-center'>
								You have no invitations to claim.
							</p>
						)
					)
				}
			</Application>
		);
	}
}

InvitationList.defaultProps = {
	username: (window.gwx && window.gwx.ui && window.gwx.ui.username) || 'User',
	helpLink: window.gwx && window.gwx.ui && window.gwx.ui.props && window.gwx.ui.props.urls && window.gwx.ui.props.urls.help,
	logoutLink: (window.gwx && window.gwx.ui && window.gwx.ui.props && window.gwx.ui.props.urls && window.gwx.ui.props.urls.logout) || '/logout',
	timeout: window.gwx && window.gwx.ui && window.gwx.ui.props && window.gwx.ui.props.timeout,
	profileId: window.gwx && window.gwx.ui && window.gwx.ui.profileId,
	profile: {}
};

InvitationList.propTypes = {
	invitations: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string.isRequired,
		communityName: PropTypes.string.isRequired,
		firstName: PropTypes.string,
		lastName: PropTypes.string,
		email: PropTypes.string.isRequired,
		communityId: PropTypes.string.isRequired
	})).isRequired,
	fetchInvitations: PropTypes.func.isRequired,
	fetchProfile: PropTypes.func.isRequired,
	isFetching: PropTypes.bool.isRequired,
	timeout: PropTypes.number,
	profileId: PropTypes.string,
	logoutLink: PropTypes.string,
	username: PropTypes.string,
	helpLink: PropTypes.string,
	profile: PropTypes.shape({
		id: PropTypes.string,
		attributes: PropTypes.arrayOf(PropTypes.string)
	})
};

const mapStateToProps = (state, props) => {
	const {
		entities: { invitations, profile }
	} = state;

	return {
		query: { size: '25', page: '0', ...parse(props.location.search) },
		noVerifiedEmail:  Object.keys(invitations.results).length === 0 ? true: false,
		invitations: invitations.ids
			.map((id) => invitations.results[id]),
		isFetching: invitations.isFetching,
		component: 'invitations',
		profile
	};
};

const mapDispatchToProps = (dispatch) => ({
	/**
	 * Makes a fetch request for the list of invitations.
	 */
	fetchInvitations: (query) => dispatch(loadInvitations(query)),

	/**
	 * Makes a fetch request for the profile.
	 * @param {*} id profile id
	 * @returns The profile object
	 */
	fetchProfile: (id) => dispatch(loadProfile(id))
});

const InvitationListContainer =	connectedComponent(InvitationList, mapStateToProps, mapDispatchToProps, true, true);

export { InvitationListContainer as default, InvitationList };
